import { Link, useLocation, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { SpaceAvatar } from "@/components/Avatars";

const REAL_ESTATE_TAB = { path: "/realestate", label: "Inmobiliaria" };

const TABS = [
  { path: "", label: "Resumen" },
  { path: "/chat", label: "Chat" },
  { path: "/files", label: "Archivos" },
  { path: "/photos", label: "Fotos" },
  { path: "/polls", label: "Encuestas" },
  { path: "/expenses", label: "Cuentas (€)" },
  { path: "/shopping", label: "Lista Compra" },
  { path: "/activity", label: "Actividad" },
];

export const SpaceTabs = ({ workspaceId }) => {
  const location = useLocation();
  const { data: ws } = useQuery({
    queryKey: ["workspace", workspaceId],
    queryFn: async () => (await api.get(`/workspaces/${workspaceId}`)).data,
  });
  const tabs = ws?.modules?.realestate ? [...TABS.slice(0, 1), REAL_ESTATE_TAB, ...TABS.slice(1)] : TABS;
  return (
    <div className="flex gap-1 overflow-x-auto border-b pb-0 -mb-px" data-testid="space-tabs">
      {tabs.map((t) => {
        const to = `/space/${workspaceId}${t.path}`;
        const active = t.path === ""
          ? location.pathname === to
          : location.pathname.startsWith(to);
        return (
          <Link key={t.label} to={to} data-testid={`space-tab-${t.label.toLowerCase()}`}
            className={`px-3 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
              active ? "border-primary text-primary" : "border-transparent text-muted-foreground hover:text-foreground"
            }`}>
            {t.label}
          </Link>
        );
      })}
    </div>
  );
};

export const SpaceSection = ({ title, actions, children }) => {
  const { id } = useParams();
  const { data: ws } = useQuery({
    queryKey: ["workspace", id],
    queryFn: async () => (await api.get(`/workspaces/${id}`)).data,
  });

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 space-y-5">
      <div className="flex items-center gap-3">
        {ws && (
          <Link to={`/space/${id}`} className="flex items-center gap-2 shrink-0" data-testid="space-section-back">
            <SpaceAvatar icon={ws.icon} color={ws.color} size="sm" />
            <span className="text-sm font-medium text-muted-foreground hover:text-foreground hidden sm:inline">{ws.name}</span>
          </Link>
        )}
        <span className="text-muted-foreground">/</span>
        <h1 className="font-heading text-lg font-bold flex-1">{title}</h1>
        {actions}
      </div>
      <SpaceTabs workspaceId={id} />
      {children}
    </div>
  );
};
